import React from 'react';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';

import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';



class ForceFormulas extends React.Component{

  render(){
    return(
      <MuiThemeProvider>
    <div style = {{paddingBottom: 60}}>
        <Table>
    <TableHeader>
      <TableRow>
        <TableHeaderColumn style = {{width: 450}}>Uses</TableHeaderColumn>
        <TableHeaderColumn>Formula</TableHeaderColumn>
      </TableRow>
    </TableHeader>
    <TableBody>
      <TableRow>
        <TableRowColumn style = {{width: 400}}>Newton's 2<sup>nd</sup> Law</TableRowColumn>
        <TableRowColumn> <img style = {{paddingRight: 100}} src = {require("./Formulas/1.png")} /> </TableRowColumn>
      </TableRow>
      <TableRow>
        <TableRowColumn style = {{width: 400}}>Gravity</TableRowColumn>
        <TableRowColumn><img style = {{paddingRight: 100}} src = {require("./Formulas/2.png")} /></TableRowColumn>
      </TableRow>
      <TableRow>
        <TableRowColumn style = {{width: 400}}>Weight</TableRowColumn>
        <TableRowColumn><img style = {{paddingRight: 100}} src = {require("./Formulas/3.png")} /></TableRowColumn>
      </TableRow>
      <TableRow>
        <TableRowColumn style = {{width: 400}}>Center of Mass</TableRowColumn>
        <TableRowColumn><img style = {{paddingRight: 100}} src = {require("./Formulas/4.png")} /></TableRowColumn>
      </TableRow>
      <TableRow>
        <TableRowColumn style = {{width: 400}}>Friction Static</TableRowColumn>
        <TableRowColumn><img style = {{paddingRight: 100}} src = {require("./Formulas/5.png")} /></TableRowColumn>
      </TableRow>
      <TableRow>
        <TableRowColumn style = {{width: 400}}>Friction Kinetic</TableRowColumn>
        <TableRowColumn><img style = {{paddingRight: 100}} src = {require("./Formulas/6.png")} /></TableRowColumn>
      </TableRow>
      <TableRow>
        <TableRowColumn style = {{width: 400}}>Torque</TableRowColumn>
        <TableRowColumn><img style = {{paddingRight: 100}} src = {require("./Formulas/7.png")} /></TableRowColumn>
      </TableRow>
    </TableBody>
  </Table>

  </div>


      </MuiThemeProvider>

    );
  }
}

export default ForceFormulas;



// WEBPACK FOOTER //
// ./src/Physics/Force/ForceFormulas.js